/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
const e={value:.5,readOnly:!0},t={readOnly:!0,value:.5,get(){return this.updating?this.updatingProgressValue:1}};export{t as updatingProgress,e as updatingProgressValue};
